export const iconFontAwesomeConnectivityTowerBroadcast = (
	<i className="fa-solid fa-tower-broadcast"></i>
);
